webpackJsonp([166499225478404],{

/***/ 280:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  align-items: stretch;\n\n  @media (max-width: 45em) {\n    flex-wrap: wrap;\n    > * {\n      width: 100%;\n      margin-bottom: ", "px;\n\n      &:not(:lang(ar)) {\n        margin-left: 0;\n      }\n      &:lang(ar) {\n        margin-right: 0;\n      }\n    }\n    > *:last-child {\n      margin-bottom: ", "px;\n    }\n  }\n  @media (min-width: 45em) {\n    flex-wrap: wrap;\n    > * {\n      width: ", ";\n      margin-bottom: ", "px;\n\n      &:not(:lang(ar)) {\n        margin-left: ", "px;\n      }\n      &:lang(ar) {\n        margin-right: ", "px;\n      }\n    }\n    > *:nth-child(2n + 1) {\n      &:not(:lang(ar)) {\n        margin-left: 0;\n      }\n      &:lang(ar) {\n        margin-right: 0;\n      }\n    }\n    /* > *:nth-last-child(-n + 2) {\n      margin-bottom: ", "px;\n    } */\n    > * {\n      &:nth-last-child(2):nth-child(odd),\n      &:last-child {\n        margin-bottom: ", "px;\n      }\n    }\n  }\n"], ["\n  align-items: stretch;\n\n  @media (max-width: 45em) {\n    flex-wrap: wrap;\n    > * {\n      width: 100%;\n      margin-bottom: ", "px;\n\n      &:not(:lang(ar)) {\n        margin-left: 0;\n      }\n      &:lang(ar) {\n        margin-right: 0;\n      }\n    }\n    > *:last-child {\n      margin-bottom: ", "px;\n    }\n  }\n  @media (min-width: 45em) {\n    flex-wrap: wrap;\n    > * {\n      width: ", ";\n      margin-bottom: ", "px;\n\n      &:not(:lang(ar)) {\n        margin-left: ", "px;\n      }\n      &:lang(ar) {\n        margin-right: ", "px;\n      }\n    }\n    > *:nth-child(2n + 1) {\n      &:not(:lang(ar)) {\n        margin-left: 0;\n      }\n      &:lang(ar) {\n        margin-right: 0;\n      }\n    }\n    /* > *:nth-last-child(-n + 2) {\n      margin-bottom: ", "px;\n    } */\n    > * {\n      &:nth-last-child(2):nth-child(odd),\n      &:last-child {\n        margin-bottom: ", "px;\n      }\n    }\n  }\n"]);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(5);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _prismicDom = __webpack_require__(10);
	
	var _rebass = __webpack_require__(4);
	
	var _components = __webpack_require__(7);
	
	var _gatsbyLink = __webpack_require__(9);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var linkResolver = function linkResolver(doc) {
	  return "/" + doc.type;
	};
	
	var Layout = (0, _styledComponents2.default)(_rebass.Flex)(_templateObject, function (props) {
	  return props.theme.space[1];
	}, function (props) {
	  return props.theme.space[0];
	}, function (props) {
	  return "calc(" + 1 / 2 * 100 + "% - " + props.theme.space[4] / 2 + "px)";
	}, function (props) {
	  return props.theme.space[5];
	}, function (props) {
	  return props.theme.space[4];
	}, function (props) {
	  return props.theme.space[4];
	}, function (props) {
	  return props.theme.space[0];
	}, function (props) {
	  return props.theme.space[0];
	});
	
	var Support = function (_React$Component) {
	  _inherits(Support, _React$Component);
	
	  function Support() {
	    _classCallCheck(this, Support);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Support.prototype.componentDidMount = function componentDidMount() {
	    this.context.setAltLanguages(undefined);
	  };
	
	  Support.prototype.render = function render() {
	    var json = "";
	    if (this.props.data.support.raw) {
	      json = JSON.parse(this.props.data.support.raw);
	    }
	    return _react2.default.createElement(
	      _rebass.Box,
	      {
	        style: this.props.transition ? this.props.transition.style : { opacity: 0 }
	      },
	      _react2.default.createElement(_components.Head, { source: json.data }),
	      _react2.default.createElement(
	        _components.Main,
	        null,
	        _react2.default.createElement(
	          _components.PageHeader,
	          { title: json.data.title[0].text, color: json.uid },
	          json.data.subtitle[0] && _react2.default.createElement(_components.H2, { children: json.data.subtitle[0].text, fontSize: [4, 5] }),
	          json.data.description[0] && _react2.default.createElement(_components.Text, { children: json.data.description[0].text }),
	          _react2.default.createElement(
	            _rebass.Box,
	            { mt: 5 },
	            _react2.default.createElement(_components.Button, {
	              children: json.lang === "en-us" ? "Donate now" : json.lang === "es-mx" ? "Donar" : "تبرّع الى مركز معلومات البنك",
	              is: "a",
	              href: "https://www.paypal.com/cgi-bin/webscr?cmd=_s-xclick&hosted_button_id=KJVPAP6TRBTEJ",
	              target: "_blank"
	            })
	          )
	        ),
	        _react2.default.createElement(
	          _components.PageSection,
	          null,
	          json.data.body1[0] && _react2.default.createElement(
	            _components.PageSidebar,
	            null,
	            _react2.default.createElement(
	              _components.CalloutContainer,
	              null,
	              json.data.body1.map(function (callout, index) {
	                return _react2.default.createElement(_components.CalloutCard, {
	                  key: "callout" + index,
	                  callout: callout.primary,
	                  lang: json.lang
	                });
	              })
	            )
	          ),
	          _react2.default.createElement(
	            _components.PageContent,
	            null,
	            json.data.body && _react2.default.createElement(_components.Article, {
	              dangerouslySetInnerHTML: {
	                __html: _prismicDom.RichText.asHtml(json.data.body, linkResolver)
	              }
	            }),
	            _react2.default.createElement(
	              _rebass.Box,
	              { mt: 6, mx: [-24, 0] },
	              json.data.action[0] && _react2.default.createElement(
	                Layout,
	                null,
	                json.data.action.map(function (actionItem, index) {
	                  return _react2.default.createElement(
	                    _components.GradientCard,
	                    { image: actionItem.action_image.url },
	                    _react2.default.createElement(
	                      _rebass.Box,
	                      null,
	                      _react2.default.createElement(_components.H4, { children: "Take Action", mb: 5 }),
	                      actionItem.action_title[0] && _react2.default.createElement(_components.H2, {
	                        children: actionItem.action_title[0].text,
	                        mb: 5,
	                        fontSize: [4, 5]
	                      }),
	                      _react2.default.createElement(_components.PrimaryButton, {
	                        children: actionItem.button_text,
	                        is: "a",
	                        href: actionItem.button_link
	                      })
	                    )
	                  );
	                })
	              )
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return Support;
	}(_react2.default.Component);
	
	Support.contextTypes = {
	  setAltLanguages: _propTypes2.default.func
	};
	exports.default = Support;
	var query = exports.query = "** extracted graphql fragment **";

/***/ })

});


// WEBPACK FOOTER //
// component---src-layouts-support-js-8b7f0f50014f5a506c7c.js